import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Helper from '../../helpers';
import axios from 'axios';
import Config from '../../config';
import { Grid, Card, CardContent, CircularProgress } from '@mui/material';

const redirect_uri = `${window.location.protocol}//${window.location.host}/oauth/channeladvisor`;

interface ChannelAdvisorSettings {
    ChannelAdvisorClientId?: string;
    [key: string]: unknown;
}

interface ChannelAdvisorAuthState {
    loading: boolean;
    error: boolean;
}

const connectOAuth = (properties: ChannelAdvisorSettings): void => {
    let clientId = properties.ChannelAdvisorClientId || 'cj164jomrfxcvlcdx0z3lvxljk5c0xgn';
    let url = `https://api.channeladvisor.com/oauth2/authorize?client_id=${clientId}&approval_prompt=force&access_type=offline&scope=orders inventory&redirect_uri=${redirect_uri}&response_type=code`;
    window.location.href = url;
}

class ChannelAdvisorAuth extends Component<{}, ChannelAdvisorAuthState> {
    state: ChannelAdvisorAuthState = {loading: true, error: false}
    async componentDidMount(){
        try{
            let qs: Record<string, string> = new Helper().queryString();
            if(qs.error){
                // Provider denial (e.g. ?error=access_denied) — do NOT fall through to
                // the initiate path (!qs.code re-fetched settings and bounced the user
                // back into consent, looping). Show the error UI.
                this.setState({error: true, loading: false});
            } else if(!qs.code){
                try{
                    let values = (await axios.get(Config.api + `/odata/Company/Functions.GetSystemSettings?system=ChannelAdvisor`)).data;
                    connectOAuth(values);
                }catch{
                    // Failed settings fetch → error UI (not an unhandled rejection + spinner).
                    this.setState({error: true, loading: false});
                }
            } else if(qs.code){
                try{
                    await axios.get(Config.api + `/odata/Company/Functions.ConnectChannelAdvisor?code=${window.encodeURIComponent(qs.code)}&redirectUri=${window.encodeURIComponent(redirect_uri)}`);
                    this.setState({loading: false});
                }catch{
                    this.setState({error: true, loading: false});
                }
            }
        }catch{
            // Malformed query (e.g. ?code=% makes queryString/decodeURIComponent throw)
            // — don't leave an unhandled rejection + stuck spinner.
            this.setState({error: true, loading: false});
        }
    }
    render(){
        if(this.state.loading){
            return <Grid container spacing={2}>
                <Grid size={{ md: 12 }}>
                    <Card>
                    <div style={{position: 'relative', marginTop: '1em'}}>
                        <CircularProgress variant={'indeterminate'} size='8em'/>
                    </div>
                    <div style={{padding: '1em'}}>{'Completing ChannelAdvisor authentication...'}</div>
                    </Card>
                </Grid>
            </Grid>;
        } else if (this.state.error){
            return <Grid container spacing={2}>
                <Grid size={{ md: 12 }}>
                    <Card>
                    <CardContent>
                    Authentication failed. Please try to connect again from the <Link to='/connections'>settings page</Link>.
                    </CardContent>
                    </Card>
                </Grid>
            </Grid>;
        }
        return <Grid container spacing={2}>
            <Grid size={{ md: 12 }}>
                <Card>
                <CardContent>
                ChannelAdvisor authentication complete!
                </CardContent>
                </Card>
            </Grid>
        </Grid>;
    }
}

export default ChannelAdvisorAuth;
export {connectOAuth as connectToChannelAdvisor};
